<template>    
    <header class="relative text-white bg-gravaabrown min-h-92">
        <CollectionBannerImage v-if="collection.coverImage" :mediaData="mediaData"/>
        <h1 class="pt-16 md:pt-24 absolute inset-0 flex items-center justify-center">{{ collection.title }}</h1>
    </header>
</template>

<script setup>

import { useBlogStore } from '@/stores/blogStore';

const blogStore = useBlogStore();

const props = defineProps({
    collection: {
        type: Object,
        required: true
    }
});

// Fetch the media data before rendering the page with a unique key
const { data: mediaData, error } = await useAsyncData(
    `mediaData-${props.collection.id}`, // Unique key based on collection ID
    async () => {
        return await blogStore.fetchMediaImageByID(props.collection.coverImage.value);
    }
);

</script>

<style scoped>
/* Add any additional styles here */
</style>

